// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__4tfT0","form":"styles_form__19an-"};